import React from 'react';
import Icon from '../ui/Icon';
import './MistakeCard.css';

// `mistake` matches getStudentMistakeBank's per-item shape, including the two
// per-item flags mistakeIntelligenceService's own thresholds already define
// (is_recurring: unresolved & mistake_count>=2; is_recently_corrected:
// resolved & a tracked retry actually succeeded) — never reinterpreted here.
// icon: a professional glyph per state (no emoji).
const STATUS = {
  recurring: { label: 'Recurring', copy: "You've missed similar questions multiple times.", tone: 'urgent', icon: 'refresh' },
  needs_recovery: { label: 'Needs recovery', copy: 'One more careful look and this is done.', tone: 'default', icon: 'mistake' },
  recently_corrected: { label: 'Recently corrected', copy: 'You got this right on retry.', tone: 'success', icon: 'success' },
  resolved: { label: 'Mastered', copy: 'Answered correctly.', tone: 'success', icon: 'check' },
};

const statusOf = (m) => {
  if (m.is_recently_corrected) return 'recently_corrected';
  if (m.is_resolved) return 'resolved';
  if (m.is_recurring) return 'recurring';
  return 'needs_recovery';
};

const MistakeCard = ({ mistake, onRetry }) => {
  const key = statusOf(mistake);
  const meta = STATUS[key];

  return (
    <div className={`z-mistake-card z-mistake-card--${meta.tone}`}>
      <div className="z-mistake-top">
        <span className="z-mistake-topic">{mistake.topic_name}</span>
        <span className={`z-mistake-status z-mistake-status--${meta.tone}`}><Icon name={meta.icon} size={14} /> {meta.label}</span>
      </div>
      <p className="z-mistake-question">{mistake.question_text}</p>
      {mistake.image_path && <p className="z-mistake-why z-mistake-chart"><Icon name="chart" size={14} /> Includes a chart — open Retry to see it.</p>}
      <p className="z-mistake-why">{meta.copy}</p>
      <div className="z-mistake-actions">
        {!mistake.is_resolved && (
          <button type="button" className="z-btn z-btn--primary z-btn--sm z-mistake-btn-retry" onClick={() => onRetry(mistake)}>
            <Icon name="refresh" size={16} /> Retry
          </button>
        )}
        {mistake.is_resolved && <span className="z-mistake-recovered"><Icon name="check" size={14} strokeWidth={3} /> Recovered</span>}
      </div>
    </div>
  );
};

export default MistakeCard;
